import { get, post, patch, del } from './client.js';

const rec = (wsId, recId) => `/workspaces/${wsId}/records/${recId}`;

const qs = (p = {}) => {
  const pairs = Object.entries(p).filter(([, v]) => v != null);
  if (!pairs.length) return '';
  return '?' + new URLSearchParams(Object.fromEntries(pairs)).toString();
};

export const listComments  = (wsId, recId, params = {})       => get(`${rec(wsId, recId)}/comments${qs(params)}`);
export const addComment    = (wsId, recId, body)               => post(`${rec(wsId, recId)}/comments`, body);
export const editComment   = (wsId, recId, cId, body)          => patch(`${rec(wsId, recId)}/comments/${cId}`, { body });
export const deleteComment = (wsId, recId, cId)                => del(`${rec(wsId, recId)}/comments/${cId}`);
export const listFollowers          = (wsId, recId)           => get(`${rec(wsId, recId)}/followers`);
export const follow                 = (wsId, recId, body)      => post(`${rec(wsId, recId)}/follow`, body);
export const unfollow               = (wsId, recId)            => del(`${rec(wsId, recId)}/unfollow`);
export const markDiscussionViewed   = (wsId, recId)            => post(`${rec(wsId, recId)}/discussion-viewed`, {});
export const getDiscussionUnread    = (wsId, recId)            => get(`${rec(wsId, recId)}/discussion-unread`);
